import { Box } from '@mui/material';
import loadingGIF from '../../Assets/loading.gif';

const Loader: any = () => {

    return (
        <Box className="data-loading-component" id="dataLoadingComponent" data-test-id="loading-indicator">
            <Box className="data-loading">
                <Box className="box">
                    <img src={loadingGIF} />
                </Box>
            </Box>
        </Box>
    )
}

export default Loader;